import React, { useContext, useState } from 'react'
import { ButtonBlue } from '../../Buttons/ButtonBlue'
import { CustomModal } from '../../CustomModal/CustomModal'
import { Spinner } from 'reactstrap'
import { t } from 'i18next'
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../../helpers/helpers'
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';
import { useNavigate } from 'react-router-dom'
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import AreasManagementContext from '../../../context/AreasManagementContext/AreasManagementContext'

export const NameOfAreas = () => {
  const navigate = useNavigate();
  const nameOfAreas = getTenantInfoByKey('area_name');

  const { areasManagementState, changeNameOfAreas, cleanAreaState } = useContext(AreasManagementContext);
  const { isFetching, responseAreaService } = areasManagementState;

  const initialState = {
    keyword: 'name_areas',
    setting_value: nameOfAreas
  }

  const [areaNameState, setAreaNameState] = useState(initialState);

  const disabled = !!!String(areaNameState.setting_value).trim();

  const handleChange = (e) => {
    let { value, name } = e.target;
    setAreaNameState({
      ...areaNameState,
      [name]: replaceExpecialCharacters(value)
    })
  }

  const handleSubmit = async () => {
    if (disabled) return
    await changeNameOfAreas(areaNameState)
  }

  const closeWarningModal = async () => {
    await cleanAreaState();
    navigate('/settings/params/nameOfEntities');
  }

  return (
    <div className='row justify-content-center w-100'>
      <div className=''>
        <div className='me-3 ms-3 mt-2'>

          <CustomModal showModal={responseAreaService.show} centered={true} setShowModal={closeWarningModal}>
            <div className='d-flex flex-column align-items-center justify-content-center'>
              <img src={responseAreaService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
              <p className='mt-3 text-center param-section-title'>{responseAreaService.text}</p>
              <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
            </div>
          </CustomModal>

          {isFetching ?
            <div className="d-flex mt-4 justify-content-center">
              <Spinner />
            </div>
            : null}

          <div>
            <p className='m-0 titlelabel-filter'>{t('DESCRIPTION')}</p>
            <p>
              <input
                className='form-control'
                type="text"
                name='setting_value'
                value={areaNameState.setting_value}
                onChange={handleChange}
              />
            </p>
          </div>

          <div className='mt-3'>
            <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
              <div className=''>
                <p type='button' className='m-0' onClick={() => navigate(-1)}>{t('CANCEL')}</p>
              </div>

              <div className=''>
                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                  {t('SAVE')}
                </ButtonBlue>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
